import { Component, OnInit } from '@angular/core';
import { DialogRef } from 'src/modules/base/components/dialog/dialog-ref';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';

@Component({
    selector: 'app-mark-flags',
    templateUrl: './mark-flags.component.html',
    styleUrls: ['./mark-flags.component.scss'],
    standalone: false
})
export class MarkFlagsComponent implements OnInit {
  form: any = {}
  data: any;
  action: any;
  constructor(private baseService: BaseService, private dialogRef: DialogRef, private alerts: AlertsService) { }

  ngOnInit(): void {
    this.baseService.getResourceDef(this.action.resource, (res) => {
      if (res) {
        this.form.formFields = res.form
        this.form.config = res.config
        let datasource = res.form.datasource
        let args = this.baseService.buildDyanamicStr(datasource.args, { data: this.data })
        this.baseService.getData({ args: args }, '', datasource.resource, datasource.application, datasource.query_id).subscribe(res => {
          if (res && res.errCode == -1)
            this.alerts.error("API Error");
          else
            this.form.data = res.resource[0]
        })
      }
    })

  }
  onSubmit(event) {
    let obj = event.result;
    if (obj['orderId'] != undefined)
      obj['orderId'] = this.data['admissionId'];
    obj['uhId'] = this.data['uhId'];
    obj['encounter_id'] = this.data['encounter_id'];
    obj['episode_id'] = this.data['episode_id'];
    this.baseService.action(obj, 'UPDATE_FLAG', 'adt', 'encounter_flags').subscribe(res => {
      if (res.errCode == 0)
        this.alerts.success('')
      this.dialogRef.close()
    })
  }

}
